import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Header from '../components/Header/Header';
import HeroSection from '../components/HeroSection/HeroSection';
import About from '../components/About/About';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import ContentCinema from '../components/ContentCinema/ContentCinema';
import ContentGames from '../components/ContentGames/ContentGames';
import Differentials from '../components/Differentials/Differentials';
import Footer from '../components/Footer/Footer';

const HEADER_HEIGHT = 78;

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => {
          window.scrollTo({
            top: el.offsetTop - HEADER_HEIGHT,
            behavior: 'smooth',
          });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Header />
      <HeroSection />
      <About />
      <HowItWorks />
      <ContentCinema />
      <ContentGames />
      <Differentials />
      <Footer />
    </>
  );
};

export default HomePage;
